<template>
  <div class="layout1" style="background: #f4f6f8">
    <van-tabs v-model="active" type="card" color="#2E94E5" @click="onClick" class="mytabs2" title-active-color="#fff">
      <van-tab title="营养状态" name="营养状态">
        <div class="mytabBox">
          <physiology :list="yyzt" @fatherMethod="fatherMethod"></physiology>
        </div>
      </van-tab>
      <van-tab title="消化系统" name="消化系统">
        <systemContent :xiaohxt="xiaohxt"></systemContent>
      </van-tab>
      <van-tab title="肠胃动力" name="肠胃动力">
        <div class="mytabBox">
          <!-- <div class="intes-ts" @click="keynoteLink()">
            报告对比
            <van-icon name="arrow" />
          </div> -->
          <van-tabs v-model="activeName" class="vantabs mytabs1 mytabsOver" swipeable :ellipsis="false" color="#2E94E5"
            animated line-height="3px" title-active-color="#2E94E5">
            <van-tab v-for="item in navData" :key="item.text" :title="item.text">
              <component v-if="item.show" :is="item.url" :list.sync="item.data" :marks="marks" :status="status"
                :report_type="report_type">
              </component>
            </van-tab>
          </van-tabs>
        </div>
      </van-tab>
    </van-tabs>
    <van-dialog class="peaceComDialog" v-model="showSuccess" title="健康分数说明" messageAlign="left"
      confirmButtonColor="#A7DDFF" closeOnClickOverlay confirmButtonText="关闭" theme="round-button" width="320"
      className="peaceH5dialogText">
      <markbox :item="fsSta"></markbox>
    </van-dialog>
  </div>
</template>
<script>
import point from "./components/point.vue"
import reportDetail from "./components/reportDetail.vue"
import systemContent from "./components/systemContent.vue"
import physiology from "../PeaceMindH5/components/physiology.vue";
import markbox from "../PeaceMindH5/components/markBox.vue"
import Disease from "@/components/Disease"
import Report from "../../models/Report";
import { Toast } from 'vant';
export default {
  components: { point, reportDetail, Disease, systemContent, physiology, markbox },
  data() {
    return {
      active: '营养状态',
      activeName: '重点关注',
      marks: 0,
      status: '',
      report_type: '',
      fsSta: {
        status: '优',
        level: 4,
        value: 85
      },
      showSuccess: false,
      yyzt: {},
      xiaohxt: {},
      navData: [
        {
          text: '重点关注', url: 'point', show: true, data: [
          ]
        },
        {
          text: '报告详情', url: 'reportDetail', show: true, data: [
          ]
        }, { text: '疾病风险', url: 'Disease', list: 'Disease', show: true, }],
    }
  },
  computed: {
    id() {
      return this.$route.query.id || "";
    },
    user_no() {
      return this.$route.query.user_no || "";
    },
  },
  mounted() {
    localStorage.setItem("token", this.$route.query.token);
  },
  created() {
    let params = {
      user_no: this.user_no,
      test_report_id: this.id,
    };
    Report.getReports({ ...params }, (res, err) => {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        className: 'tianlei',
        duration: 0,
        loadingType: 'spinner',
      });
      if (!err) {
        console.log(res)
        this.xiaohxt = res.xiaohxt
        this.yyzt = res.yyzt
        this.report_type = res.report_type
        
        this.xiaohxt.son.forEach((item) => {
          item.son.forEach((itemA) => {
            if (itemA.performance) {
              itemA.performance = itemA.performance.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
              itemA.suggestion = itemA.suggestion.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
              itemA.performance = itemA.performance ? itemA.performance.split('\\r\\n') : []
              itemA.suggestion = itemA.suggestion ? itemA.suggestion.split('\\r\\n') : []
            }
          })
        })
        console.log(this.xiaohxt)
        this.yyzt.son.forEach((item) => {
          item.son.forEach((itemA) => {
            if (itemA.performance) {
              itemA.performance = itemA.performance.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
              itemA.suggestion = itemA.suggestion.split('<b>').join('<b style="margin-bottom:5px;margin-top:10px;display:inline-block">')
              itemA.performance = itemA.performance ? itemA.performance.split('\\r\\n') : []
              itemA.suggestion = itemA.suggestion ? itemA.suggestion.split('\\r\\n') : []
            }
          })
          item.gs = item.risk.length
        })
        let arr = res.im_power
        arr.forEach((item) => {
          item.exam_references = item.exam_references.replace(/\\r\\n/g, '<br/>')
          item.remakrs = item.remakrs.replace(/\\r\\n/g, '<br/>')
        })
        let zdData = []
        let xqData = []
        let echartsList = []
        arr.forEach((item) => {
          echartsList.push({
            name: item.name,
            value: item.value
          })
          if (item.is_focus == 1) {
            zdData.push(item)
          }
        })
        arr.forEach((item) => {
          item.echartsList = echartsList
        })
        this.marks = res.marks
        this.status = res.status
        this.navData[0].data = zdData // 重点关注
        this.navData[1].data = arr // 
        if (res.power_disease !== undefined) {
          res.power_disease.disease_polyp_chang = JSON.parse(JSON.stringify(res.power_disease.disease_polyp_chang).replace(/直肠息肉/g, "肠息肉"))
          this.navData[2].data = res.power_disease
        }
        this.active = this.$store.state.activeName1
        setTimeout(() => {
          Toast.clear()
        }, 1500)


      }
    });
  },
  methods: {

    onClick(name, title) {
      this.$store.commit('changeActiveName1', title)
      document.title = title == '营养状态' ? '营养评估' : title
    },
    keynoteLink() {
      this.$router.push({ path: '/reportComparison', query: { user_no: this.user_no } });
    },
    fatherMethod() {
      this.showSuccess = true
    },
  }
}
</script>
<style lang="scss" >
.layout1 {
  box-sizing: border-box;
  padding: 15px 20px;
  text-align: left;

  .mytabBox {
    padding-top: 30px;
  }

  .dis-wrap-top {
    text-align: center;
  }

  .details .dis-top .back {
    text-align: center;
  }

  .pointList .van-cell {}

  .van-tabs--line .van-tabs__wrap {
    position: static;
  }
}

.tianlei {
  padding: 20px !important;
  font-size: 26px !important;
}

.tianlei .van-toast__text {
  font-size: 26px !important;
}

.intes-bg {
  background: #ffffff;
}

.intes-bt {
  padding: 24px 20px;
  font-size: 30px;
  color: #666;
}

.intes-ts {
  height: 60px;
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  justify-content: space-between;
  color: #e28c3f;
  font-size: 26px;
  padding: 0 20px;
  text-align: left;
  background: #ffe8b8;
  border-radius: 4px;
}

.bgBoxtit {
  font-size: 28px;
  color: #333;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ul {
    li {
      display: inline-block;
      margin-right: 10px;

      span {
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    li:nth-child(1) {
      span {
        background: #3195e6;
      }
    }

    li:nth-child(2) {
      span {
        background: #9ef133;
      }
    }

    li:nth-child(3) {
      span {
        background: #f1be33;
      }
    }
  }
}

.van-toast {
  width: auto !important;
}

.pointImg {
  img {
    width: 40px;
    height: 49px;
    vertical-align: middle;
    margin-right: 10px;
  }
}

.mytabs1 {
  margin-top: 20px;

  //padding-bottom: 0;
  .van-tabs__wrap {

    //width: calc(100%);
    .van-tab__text--ellipsis {
      // overflow: visible;
    }
  }

  //box-sizing: border-box;
  // overflow: hidden;
  //font-size: 14px;
  .van-tabs__nav,
  .van-tabs--line .van-tabs__wrap {
    background: none;
  }
}

.mytabs2 {
  margin-top: 20px;

  //padding-bottom: 0;
  .van-tabs__wrap {
    height: 80px !important;
    line-height: 80px !important;

    .van-tabs__nav {
      height: 80px;
    }

    .van-tab {}
  }
}

.pointList {
  .van-cell {
    padding: 30px 20px !important;
    font-size: 30px !important;
  }

  .van-collapse-item--border::after {
    border-color: #e3e1e1;
  }
}
</style>